export const normalizeTag = (tag) => tag.toLowerCase();
